import React from 'react'
import cn from 'classnames'
// @ts-ignore
import ArrowTop from 'app/components/SVGS/ArrowTop'

import { ITitleForCompetencySectionProps } from './interface'
import './styles.scss'

const bc = 'title-for-competency-section'

const TitleForCompetencySection: React.FC<ITitleForCompetencySectionProps> = ({
  title,
  isOpened,
  handleToggle,
  overall,
}) => {
  return (
    <div className={cn(`${bc}__wrapper`, { [`${bc}__wrapper--closed`]: !isOpened })}>
      <div className={`${bc}__title`}>{title}</div>
      <div className={`${bc}__overall`}>
        <div>OVERALL CHANGE</div>
        <div className={`${bc}__overall-number`}>{overall}</div>
        <ArrowTop className={cn(`${bc}__arrow`, { [`${bc}__arrow-bottom`]: !isOpened })} onClick={handleToggle} />
      </div>
    </div>
  )
}

export default TitleForCompetencySection
